<template>
<div id="Home">

</div>
</template>

<script>
const fb = require('../config/db.js');

export default {
  name: 'Home',
  data() {
    return {
      showModal: false
    }
  },

}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>


</style>
